// extracted by mini-css-extract-plugin
export default {"menuWrapper":"Lfs6oB99","menu":"EJsuJXfx","menuItem":"J7O_MmwF"};